export default __webpack_public_path__ + "static/media/Background 5_00071.a9f0266f.png";